export default __webpack_public_path__ + "static/media/disminuir-el-zoom.ca69bf93.png";